import './designers-showcase.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initDesignersShowcase = (context) => {
  const designersShowcaseSection = context.closest('.shopify-section');
  if (!designersShowcaseSection) return;

  designersShowcaseSection
    .querySelectorAll('.designers-showcase__slider-wrapper')
    .forEach((slider) => {
      const slides = slider.querySelectorAll('.swiper-slide:not(:first-child)');
      Array.from(slides)
        .map((slide) => {
          return {
            position: Math.floor(Math.random() * slides.length + 1),
            id: slide.id,
          };
        })
        .sort((a, b) => a.position - b.position)
        .forEach((orderEl) => {
          const slide = slider.querySelector(`#${orderEl.id}`);
          if (!slide) return;
          slide.parentElement.appendChild(slide);
        });

      window.requestAnimationFrame(() => {
        new Swiper(slider, {
          loop: true,
          speed: 500,
          disableOnInteraction: false,
          allowTouchMove: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          autoplay: {
            delay: slider?.dataset?.autoplaySpeed
              ? slider.dataset.autoplaySpeed
              : 2500,
          },
        });
      });
    });
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.designers-showcase__container'),
    (el) => {
      window.dAgency.initDesignersShowcase(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.designers-showcase__container'),
      (el) => {
        window.dAgency.initDesignersShowcase(el);
      },
    );
  });
}
